import React from 'react';
import { inject } from 'mobx-react';

import Money from 'components/Money';
import { localizable } from 'components/Localization';
import BaseStep from '../components/BaseStep';

@inject('app')
@localizable
class AwardSummary extends BaseStep {
  render() {
    const {
      store: { message, rejectMessage, selectedBuyer, rejectedOfferDetails },
      t,
    } = this.props;

    return (
      <div>
        <h2>{t('Summary')}</h2>

        <h2>{t('Selected winner')}</h2>

        <div>{this.renderBuyerName(selectedBuyer.item)}</div>
        <div>
          {t('Offer')}:{' '}
          <Money
            value={selectedBuyer.submittedValue}
            currency={this.props.app.currency.code}
            locale={this.props.intl.locale}
          />
        </div>

        <h3>{t('Additional information text')}</h3>

        <p>{message || <i>{t('Not entered')}</i>}</p>

        <h2>{t('Rejected customers offers')}</h2>
        <ol>
          {rejectedOfferDetails &&
            rejectedOfferDetails.map((i) => (
              <li key={i.buyerId}>{this.renderBuyerName(i.item)}</li>
            ))}
        </ol>

        <h3>{t('Additional information text')}</h3>
        <p>{rejectMessage || <i>{t('Not entered')}</i>}</p>

        <p>
          {t('If you click "Finish", you confirm the winner')}
          <br />
          {t('This action cannot be undone.')}
        </p>
      </div>
    );
  }
}

export default AwardSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Award/Summary.jsx